module.exports = __webpack_public_path__ + "images/proxy-2.1d8e.png";